import axios from "axios";

export const GetLanguages = (mentorId) => {
  return axios.get(`/languages?mentor_id=${mentorId}`);
};

export const SyncLanguages = (mentorId, data) => {
  return axios.post(`/mentor-languages/mentors/${mentorId}/sync`, data);
};

/**
 * Fetch the list of languages available for subtitle upload.
 * GET /languages/subtitle
 * Response: { data: [{ id, name, identifier, ... }] }
 */
export const GetSubtitleLanguages = () => {
  return axios.get(`/languages/subtitle`);
};
